import { createContext } from 'react';

const DrawerContext = createContext(null);

export default DrawerContext;
